import { fetcher } from '@commenda/utils';
import useSWR from 'swr';
import {
  IIndirectTaxPortalFieldsV2Params,
  IIndirectTaxPortalFieldsV2Response,
} from './types';

export function useIndirectTaxRegistrationPortalFields(
  params: IIndirectTaxPortalFieldsV2Params | null
) {
  const cacheKey = params
    ? `new-sales-tax/registrations-v2/content/portal-fields:${params.corporationId}:${params.portalIds.sort().join(',')}`
    : null;

  const { data, mutate, error, isLoading } =
    useSWR<IIndirectTaxPortalFieldsV2Response>(cacheKey, async () => {
      if (!params) {
        throw new Error('Params required');
      }
      const response = await fetcher(
        'new-sales-tax/registrations-v2/content/portal-fields',
        { method: 'POST', body: params },
        undefined
      );
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch portal fields');
      }
      return response.json();
    });

  return {
    data,
    mutate,
    error,
    isLoading,
  };
}
